import React from 'react';
import PropTypes from 'prop-types';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { AuthProvider } from 'context/auth';
import { FetchProvider } from 'context/fetch';
import { HeaderColorProvider } from 'context/header-color';

const queryClient = new QueryClient();

function Context({ children }) {
  return (
    <Router>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <HeaderColorProvider>
            <AuthProvider>
              <FetchProvider>{children}</FetchProvider>
            </AuthProvider>
          </HeaderColorProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </Router>
  );
}

Context.propTypes = {
  children: PropTypes.node,
};

Context.defaultProps = {
  children: null,
};

export default Context;
